export const paths = {
  account: '/settings',
  editCompany: '/settings/company-edit',
  editUser: '/settings/edit',
  faq: '/settings/faq',
  membership: '/settings/membership',
  updatePassword: '/settings/update-password',
  userMembership: '/user/membership',
};
